module.exports = __webpack_public_path__ + "media/images/photo/photo-og-image-8c798b304ec7991706dcd1a393ae5c05.png";